import Route from '@ember/routing/route';

export default class LibraryFoldersRoute extends Route {}
